import { useState } from 'react';
import { KIT_FALLBACK_IMAGE } from '../../config/media';

const KitItemThumbnail = ({ item, size = 'md', getImageUrl }) => {
  const [hadError, setHadError] = useState(false);
  const dimensionClass = size === 'sm' ? 'w-16 h-16' : 'w-24 h-24';
  const radiusClass = size === 'sm' ? 'rounded-xl' : 'rounded-2xl';
  const resolvedSrc = getImageUrl ? getImageUrl(item) : undefined;
  const src = !resolvedSrc || hadError ? KIT_FALLBACK_IMAGE : resolvedSrc;

  return (
    <div className={`${dimensionClass} ${radiusClass} overflow-hidden bg-gray-100 flex items-center justify-center border border-gray-200`}>
      <img
        src={src}
        alt={item.title}
        className="w-full h-full object-cover"
        loading="lazy"
        onError={() => setHadError(true)}
      />
    </div>
  );
};

export default KitItemThumbnail;
